import { Component } from "react";
import { connect } from "react-redux";

import { getCommitmentsByAssignmentManagerId } from "views/invoices/Services";
import { pluralize } from "common/pluralize/pluralize";
import { Loader } from "components/loader/Loader";
import Commitment from "./Commitment";

class AssignmentManagerCommitments extends Component {
  componentDidMount() {
    this.props.dispatch(
      getCommitmentsByAssignmentManagerId(
        this.props.selectedAssignmentManager.id
      )
    );
  }

  render() {
    return (
      <div>
        {this.props.gettingCommitments && <Loader />}
        {!this.props.gettingCommitments && (
          <>
            <p>
              Det finns{" "}
              {pluralize(
                this.props.commitments.length,
                "uppdrag",
                "uppdrag",
                "inga"
              )}{" "}
              att granska
            </p>

            {this.props.commitments
              .sort((x, y) => {
                // Sort by kontor
                if (x.kontor > y.kontor) {
                  return 1;
                } else if (x.kontor < y.kontor) {
                  return -1;
                } else {
                  // if they're the same, sort by uppdrag instead
                  if (x.uppdrag > y.uppdrag) {
                    return 1;
                  } else if (x.uppdrag < y.uppdrag) {
                    return -1;
                  } else {
                    // if uppdrag is the same, sort by kundnummer
                    if (x.kundnummer > y.kundnummer) {
                      return 1;
                    } else if (x.kundnummer < y.kundnummer) {
                      return -1;
                    } else {
                      return 0;
                    }
                  }
                }
              })
              .map((item) => {
                return (
                  <Commitment
                    key={item.id}
                    commitmentId={item.id}
                    commitment={item}
                  />
                );
              })}
          </>
        )}
      </div>
    );
  }
}

export default connect((state) => {
  return {
    commitments: state.invoices.commitments,
    gettingCommitments: state.invoices.gettingCommitments
  };
})(AssignmentManagerCommitments);
